import {CRM_ENTRY_USER, CRM_SUPER_USER} from '@/constants/roles'
export const CLIENTS_TAB_ID = 'clients'
export const PARTNERS_TAB_ID = 'partners'
export const VENDORS_TAB_ID = 'vendors'

export const CRM_TAB_LIST = [
  { id: 1, tabId: CLIENTS_TAB_ID, title: 'Clients' },
  { id: 2, tabId: PARTNERS_TAB_ID, title: 'Partners', restrictedRoles: [CRM_ENTRY_USER, CRM_SUPER_USER] },
  { id: 3, tabId: VENDORS_TAB_ID, title: 'Vendors' }
]

export const CRM_STATUS_TABS = [
  {id: 1, tabId: 'active', title: 'Active'},
  {id: 2, tabId: 'prospect', title: 'Prospect'},
  {id: 3, tabId: 'nonActive', title: 'Non-Active'}
]



// WEBPACK FOOTER //
// ./src/constants/crm/index.js